// src/components/forms/formSteps/DetailsStep.tsx
import React from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import { useTranslation } from "../../hooks/useTranslation";

interface DetailsStepProps {
  caseDescription: string;
  validation: { valid: boolean; error: string };
  onChange: (field: string, value: string) => void;
  onSubmit: () => void; // Added explicit submit handler
  isMobile: boolean;
}

const DetailsStep: React.FC<DetailsStepProps> = ({
  caseDescription,
  validation,
  onChange,
  onSubmit,
  isMobile,
}) => {
  // Handle keydown event - only update field, don't auto-submit
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      // Don't auto-submit on Enter key - just prevent default behavior
    }
  };

  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h6" align="center" sx={{ color: "#c6c6c6", mb: 2 }}>
        Question 4 out of 5
      </Typography>
      <Typography variant="h6" align="center" sx={{ mb: 3 }}>
        4. {t("form.fourthQuestion.question")}{" "}
        <span style={{ color: "red" }}>*</span>
      </Typography>

      <TextField
        fullWidth
        multiline
        rows={4}
        placeholder={t("form.fourthQuestion.placeholder")}
        value={caseDescription}
        onChange={(e) => {
          onChange("caseDescription", e.target.value);
        }}
        onKeyDown={handleKeyDown}
        error={!validation.valid}
        helperText={validation.error}
        sx={{ mb: 1 }}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 1,
          mb: 2,
        }}
      >
        <Typography
          variant="caption"
          color={
            caseDescription.length < 40
              ? "error"
              : caseDescription.length > 500
              ? "error"
              : "text.secondary"
          }
        >
          {t("form.fourthQuestion.minChars")}
        </Typography>
        <Typography
          variant="caption"
          color={caseDescription.length > 500 ? "error" : "text.secondary"}
        >
          {caseDescription.length}/{t("form.fourthQuestion.fiveHundred")}
        </Typography>
      </Box>

      <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          size="large"
          onClick={onSubmit}
          disabled={
            caseDescription.trim() === "" ||
            caseDescription.length < 40 ||
            caseDescription.length > 500
          }
          sx={{
            minWidth: "200px",
            py: 1.5,
            fontWeight: "bold",
            backgroundColor: "#ff6b35",
            "&:hover": {
              backgroundColor: "#e25a2a",
            },
          }}
        >
          Continue
        </Button>
      </Box>
    </>
  );
};

export default DetailsStep;
